function initAutoScroll({ containerSelector, itemSelector, duration }) {
  const scrollContainer = document.querySelector(containerSelector);
  const items = document.querySelectorAll(itemSelector);
  const itemWidth = items[0].offsetWidth;
  let scrollCounter = 0;
  let scrollInterval;
  function autoScroll() {
    scrollCounter += itemWidth;
    scrollContainer.scrollTo({
      left: scrollCounter,
      behavior: 'smooth'
    });
    if (scrollContainer.scrollLeft + scrollContainer.clientWidth >= scrollContainer.scrollWidth) {
      scrollContainer.scrollTo({ left: 0, behavior: 'smooth' });
      scrollCounter = 0;
    }
  }
  function resetScrollInterval() {
    clearInterval(scrollInterval);
    scrollInterval = setInterval(autoScroll, duration);
  }
  scrollInterval = setInterval(autoScroll, duration);
  scrollContainer.addEventListener('wheel', resetScrollInterval);
  scrollContainer.addEventListener('scroll', () => {
    resetScrollInterval();
    checkVisibleItem();
    setTimeout(() => {
      scrollCounter = scrollContainer.scrollLeft;
    }, 50);
  });
  function checkVisibleItem() {
    if (window.innerWidth <= 561) {
      items.forEach(item => {
        const rect = item.getBoundingClientRect();
        const isVisible = rect.left >= 0 && rect.right <= window.innerWidth;
        if (isVisible) {
          item.classList.add('ct-autoscroll-visible');
        } else {
          item.classList.remove('ct-autoscroll-visible');
        }
      });
    }
  }
  checkVisibleItem();
}

